// src/pages/JourneyMap/components/EdyAssistant.jsx
import React, { useState, useEffect } from 'react';

/**
 * Edy — bolha de fala da jornada (robô exibido no painel direito).
 * Props:
 *   message   — string ou null
 *   mood      — 'default' | 'joinha' | 'rocket' | 'think' | 'celebrate'
 *   loading   — bool (exibe typing dots)
 */
export default function EdyAssistant({ message, mood = 'default', loading = false }) {
  const [displayed, setDisplayed] = useState('');
  const [typing, setTyping]       = useState(false);

  // Efeito de digitação progressiva
  useEffect(() => {
    if (!message) return;
    setTyping(true);
    setDisplayed('');
    let i = 0;
    const interval = setInterval(() => {
      setDisplayed(message.slice(0, i + 1));
      i++;
      if (i >= message.length) {
        clearInterval(interval);
        setTyping(false);
      }
    }, 14);
    return () => clearInterval(interval);
  }, [message]);

  // Notifica o painel do robô sobre a mudança de mood via CustomEvent
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('edy-mood', { detail: mood }));
  }, [mood]);

  return (
    <div className="edy">
      <div className="edy__bubble">
        {loading || (!message && !displayed) ? (
          <div className="edy__typing" aria-label="Eddy está digitando">
            <span /><span /><span />
          </div>
        ) : (
          <span>
            {displayed}
            {typing && <span className="edy__cursor">▌</span>}
          </span>
        )}
      </div>
    </div>
  );
}
